import { Sparkle } from "lucide-react";

const ITEMS = [
  "PERMANENT TRIM LIGHTING",
  "HOLIDAY & CHRISTMAS",
  "LANDSCAPE & PATIO",
  "WEDDINGS & EVENTS",
  "INDOOR & OUTDOOR",
  "AUTOMOBILE",
  "SALT LAKE COUNTY",
  "PRICE-BEAT GUARANTEE",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="services-marquee" className="relative overflow-hidden border-y border-gold/15 bg-[#0C0D11] py-5">
      <div className="animate-marquee flex w-max items-center gap-10 pr-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="font-serif text-lg sm:text-xl tracking-[0.2em] text-slate-400">{item}</span>
            <Sparkle className="h-4 w-4 text-gold shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}
